import { useEffect } from "react";

// CSS viewport units alone do not consistently account for the phone keyboard.
export default function useVisualViewport() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    const root = document.documentElement;
    let frame = 0;
    let previous = "";
    const update = () => {
      frame = 0;
      // Keep pinch zoom native rather than shrinking the layout under the user.
      if (Math.abs(viewport.scale - 1) > 0.05) return;
      const height = `${Math.round(viewport.height)}px`;
      const top = `${Math.max(0, Math.round(viewport.offsetTop))}px`;
      const next = height + top;
      if (previous === next) return;
      previous = next;
      root.style.setProperty("--visible-height", height);
      root.style.setProperty("--visible-top", top);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    update();
    viewport.addEventListener("resize", schedule, { passive: true });
    viewport.addEventListener("scroll", schedule, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      viewport.removeEventListener("resize", schedule);
      viewport.removeEventListener("scroll", schedule);
      root.style.removeProperty("--visible-height");
      root.style.removeProperty("--visible-top");
    };
  }, []);
}
